/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.11",
    versionName: "0.2.0-nightly.2025.9.11",
    versionChannel: "nightly",
    buildDate: "2025-09-11T00:07:16.413Z",
    commitHash: "ab5992df6aa0fa98c530956baf2d483a11c77fda",
};
